import {forwardRef, Ref} from 'react';
import moment from 'moment';
import {FormControl} from '@mui/material';
import {MobileTimePicker, MobileTimePickerProps} from '@mui/x-date-pickers';
import {DailyCareInput} from '../daily-care-input';
import {MdOutlineAccessAlarms} from 'react-icons/md';

interface DailyCareTimeInputProps extends MobileTimePickerProps<Date> {
  id?: string;
  label?: string;
  required?: boolean;
  errors?: string;
}

export const DailyCareTimeInput = forwardRef(
  (
    {label, required, disabled, errors, ...rest}: DailyCareTimeInputProps,
    ref: Ref<HTMLInputElement>
  ) => {
    return (
      <FormControl className="flat-starts-at-time" sx={{width: '100%', ...rest.sx}}>
        <MobileTimePicker
          {...rest}
          // @ts-ignore
          value={moment(rest.value)}
          label={label}
          slots={{
            textField: ({value, onChange, onBlur, onClick, inputProps}) => {
              return (
                <DailyCareInput
                  {...{onChange, onBlur, disabled, label, required}}
                  ref={ref}
                  onClick={onClick}
                  inputProps={{
                    ...inputProps,
                    // @ts-ignore
                    value: value,
                  }}
                  shrinkLabel={true}
                  startAdornment={<MdOutlineAccessAlarms size={22} style={{marginRight: '8px'}} />}
                />
              );
            },
          }}
        />
      </FormControl>
    );
  }
);
